export enum GroupType {
  Regular = 'REGULAR',
  NomineeRegular = 'NOMINEE-REGULAR',
  InboundNominee = 'INBOUND-NOMINEE',
}
